var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VIcon',{attrs:{"type":_vm.computedType,"color":_vm.color,"fallback":_vm.fallback,"size":"large"}})
}
var staticRenderFns = []

export { render, staticRenderFns }